/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-23 13:17:28
 * @Explain: 发件人
 */
import http from '../http';

const MODEL = '/sender';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data);
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update`, data);
  },
  // 详情
  onDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/details`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data);
  },
};
